import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { CalendarRange, LayoutDashboard, LogIn } from "lucide-react";

const linkCls = ({ isActive }) =>
  `inline-flex items-center gap-2 rounded-sm px-3 py-2 text-sm font-medium transition-colors ${isActive ? "text-amber-400" : "text-slate-300 hover:text-white"}`;

export const Navbar = () => (
  <header className="sticky top-0 z-50 border-b border-slate-800/80 bg-slate-950/80 backdrop-blur-xl">
    <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-8">
      <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
        <img src="/logo.png" alt="Floor LED 360" className="h-12 w-auto drop-shadow-[0_0_12px_rgba(225,6,0,0.35)]" />
        <span className="hidden font-display text-lg font-bold uppercase leading-none tracking-wide sm:block">Floor LED <span className="text-amber-400">360</span><span className="block font-mono text-[10px] font-normal tracking-[0.25em] text-slate-400">Agenda de eventos</span></span>
      </Link>
      <nav className="flex items-center gap-1">
        <NavLink to="/" end className={linkCls} data-testid="nav-agenda-link"><span className="hidden sm:inline">Agenda</span><CalendarRange size={16} className="sm:hidden" /></NavLink>
        <Show when="signed-in">
          <NavLink to="/painel" className={linkCls} data-testid="admin-dashboard-link"><LayoutDashboard size={16} /><span className="hidden sm:inline">Painel</span></NavLink>
          <div className="ml-2" data-testid="user-menu"><UserButton /></div>
        </Show>
        <Show when="signed-out">
          <Link to="/sign-in" data-testid="nav-login-button" className="ml-2 inline-flex items-center gap-2 rounded-sm bg-amber-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-amber-400">
            <LogIn size={16} />Entrar
          </Link>
        </Show>
      </nav>
    </div>
  </header>
);
